import React, { Component } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { withTranslation } from 'react-i18next';

class WrappedAutocomplete extends Component {

    render() {
        return (
            <Autocomplete
                fullWidth
                disabled={this.props.disabled}
                multiple={this.props.multiple}
                value={this.props.value}
                id={this.props.name}
                name={this.props.name}
                size="small"
                options={this.props.options}
                onChange={(e, obj) => this.props.onChange(obj)}
                autoHighlight
                getOptionLabel={this.props.getOptionLabel}
                getOptionSelected={this.props.getOptionSelected}
                getOptionDisabled={this.props.getOptionDisabled}
                renderOption={this.props.renderOption}
                noOptionsText={this.props.t("no_options")}
                renderInput={params => (
                    <TextField
                        {...params}
                        label={this.props.t(this.props.label)}
                        placeholder={this.props.t(this.props.inputLabel)}
                        variant="outlined"
                        fullWidth
                        required={this.props.required}
                        inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off',
                            form: {
                                autocomplete: 'off',
                            }, // disable autocomplete and autofill
                        }}
                    />
                )}
            />
        );
    }
}

export default withTranslation()(WrappedAutocomplete);
